import Model from '@models/model';

export default class Setting extends Model {
    resource() {
        return 'settings';
    }
}
